export const CONTACT_INIT_VALUES = {
  name: '',
  email: '',
  phone: '',
};
